// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Occupancy-module__wrapper___URu7B"};